// Visual helpers for the 1-9 assessment scale and overall /45 bands.

export const DOMAIN_BANDS = [
  { key: "emerging", name: "Emerging", min: 1, max: 3 },
  { key: "developing", name: "Developing", min: 4, max: 6 },
  { key: "secure", name: "Secure", min: 7, max: 8 },
  { key: "advanced", name: "Advanced", min: 9, max: 9 },
];

// styling per band key
export const BAND_STYLE = {
  emerging: { dot: "bg-red-400", bg: "bg-red-50", text: "text-red-700", border: "border-red-200", solid: "#E57373", soft: "#FBE3E3" },
  early_developing: { dot: "bg-orange-400", bg: "bg-orange-50", text: "text-orange-700", border: "border-orange-200", solid: "#F0A868", soft: "#FBEAD8" },
  developing: { dot: "bg-amber-400", bg: "bg-amber-50", text: "text-amber-700", border: "border-amber-200", solid: "#F6C358", soft: "#FBF0D6" },
  secure: { dot: "bg-emerald-400", bg: "bg-emerald-50", text: "text-emerald-700", border: "border-emerald-200", solid: "#81B29A", soft: "#DCEBE4" },
  advanced: { dot: "bg-sky-400", bg: "bg-sky-50", text: "text-sky-700", border: "border-sky-200", solid: "#7D98A1", soft: "#E0E9EC" },
};

export function levelBand(level) {
  if (!level) return null;
  if (level <= 3) return "emerging";
  if (level <= 6) return "developing";
  if (level <= 8) return "secure";
  return "advanced";
}

export function levelStyle(level) {
  return BAND_STYLE[levelBand(level)] || BAND_STYLE.emerging;
}

export const OVERALL_BANDS = [
  { key: "emerging", name: "Emerging", min: 5, max: 15, summary: "Needs intensive support; foundational skills not secure" },
  { key: "early_developing", name: "Early Developing", min: 16, max: 25, summary: "Some skills present; inconsistent across domains" },
  { key: "developing", name: "Developing / On Track", min: 26, max: 35, summary: "Meeting many expectations; some gaps remain" },
  { key: "secure", name: "Secure", min: 36, max: 41, summary: "Strong, consistent performance across most domains" },
  { key: "advanced", name: "Advanced", min: 42, max: 45, summary: "Exceeding expectations; applies skills flexibly" },
];

export function overallBand(total) {
  for (const b of OVERALL_BANDS) if (total >= b.min && total <= b.max) return b;
  return total < 5 ? OVERALL_BANDS[0] : OVERALL_BANDS[OVERALL_BANDS.length - 1];
}

export const SUBJECT_META = {
  literacy: { name: "Literacy", icon: "BookOpen", tint: "#6C8EBF" },
  numeracy: { name: "Numeracy", icon: "Calculator", tint: "#C08552" },
  social_emotional: { name: "Social & Emotional", icon: "HeartHandshake", tint: "#9A7AA0" },
};

// ASDP is an optional, per-student category — kept out of class-wide SUBJECT_META
// iteration, but available for individual-student lookups via SUBJECT_META_ALL.
export const ASDP_META = {
  asdp: { name: "Autism Support & Development", icon: "Puzzle", tint: "#3E9B96" },
};

export const SUBJECT_META_ALL = { ...SUBJECT_META, ...ASDP_META };

// ASDP uses neurodiversity-affirming band labels for the level scale.
export const ASDP_BAND_LABELS = ["Supported", "Developing", "Independent", "Self-Adv"];

export const TARGET_STATUS = {
  not_started: { name: "Not Started", text: "text-slate-600", bg: "bg-slate-100" },
  in_progress: { name: "In Progress", text: "text-amber-700", bg: "bg-amber-100" },
  achieved: { name: "Achieved", text: "text-emerald-700", bg: "bg-emerald-100" },
};
